/* eslint-disable */
(() => (document.cookie.match(/mp_\w+_mixpanel/g)||[]).forEach(o=>document.cookie=`${o}=''; max-age=0; path=/; domain=.collegeboard.org;`))();
